import React from 'react';
import PropTypes from 'prop-types';

const FileUpload = ({
  onFileDrop,
  ...props
}) => {
  const handleOnDragOver = event => {
    event.stopPropagation();
    event.preventDefault();

    const el = document.getElementById('kt-file-dropzone');
    el.style.opacity = 0.25;
  };

  const handleDragLeave = event => {
    event.stopPropagation();
    event.preventDefault();

    const el = document.getElementById('kt-file-dropzone');
    el.style.opacity = 1;
  };

  const handleOnDrop = event => {
    event.stopPropagation();
    event.preventDefault();

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const files = event.dataTransfer.files;
      // multiple files can be dropped but we're only allowing one upload per drop
      const file = files[0];
      onFileDrop && onFileDrop(file);

      const el = document.getElementById('kt-file-dropzone');
      el.style.opacity = 1;
    }
  };

  /**
   * assumes `props.children` is a SINGLE component so only pass ONE component
   * will shallow clone `onDragOver`, `onDragLeave`, and `onDrop` to the wrapped component
   */
  return React.cloneElement(props.children, {
    id: 'kt-file-dropzone',
    onDragOver: handleOnDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleOnDrop
  });
};

FileUpload.propTypes = {
  onFileDrop: PropTypes.func.isRequired
};

export default FileUpload;
